import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bankCard', standalone: true })
export class BankCardPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if (value) {
      const parts = value!.match(/.{1,4}/g);
      return parts!.join('-');
    }
    return '';
  }
}
